import { BaseDTO } from './base-dto';
import { MarketLevel } from './market-level';
import { Organization } from './organization';
import { SalesCenter } from './sales-center';
import {PriceList} from './price-list';

export class Market extends BaseDTO {
    Code: string;
    Name: string;
    Organization: Organization;
    MarketLevel: MarketLevel;
    Parent: Market;
    ParentList: Market[];
    SalesCenter: SalesCenter;
    EffectiveSalesCenter: SalesCenter;
    Weekends: any;
    ShiftStartTime: string;
    ShiftEndTime: string;
    Market: Market;
    PriceList: PriceList;
    EffectivePriceList: PriceList;
    
    constructor( pId?: number ) {
        super();
        if ( pId ) {
            this.Id = pId;
        }
    }
}
